<div class="login-page">
  <!--<div class="card x_panel" id="login">-->
    <div class="card" id="login">
      <div class="imgcontainer">
        <img src="../../../assets/images/viresco.png" width="100px" />
      </div>
      <br />
      <br />
      <br />
      <button (click)="RealizarLogin()">Login</button>
    </div>
  </div>
